import React, { useState } from 'react';
import { ClipboardCheck, BarChart3, List, ArrowLeft } from 'lucide-react';
import { QADashboard } from '../components/content-qa/QADashboard';
import { QAQuestionList } from '../components/content-qa/QAQuestionList';
import { QAQuestionDetail } from '../components/content-qa/QAQuestionDetail';

type View = 'dashboard' | 'list' | 'detail';

export const ContentQAPage: React.FC = () => {
  const [currentView, setCurrentView] = useState<View>('dashboard');
  const [selectedQuestionId, setSelectedQuestionId] = useState<string | null>(null);

  const handleSelectQuestion = (id: string) => {
    setSelectedQuestionId(id);
    setCurrentView('detail');
  };

  const handleBack = () => {
    if (currentView === 'detail') {
      setCurrentView('list');
      setSelectedQuestionId(null);
    } else {
      setCurrentView('dashboard');
    }
  };

  return (
    <div>
      {/* Page Header */}
      <div className="page-header">
        <div className="flex items-center gap-3">
          {currentView !== 'dashboard' && (
            <button className="btn btn-ghost btn-sm" onClick={handleBack}>
              <ArrowLeft size={16} />
            </button>
          )}
          <h1>
            <ClipboardCheck size={24} /> Content QA
          </h1>
        </div>

        {/* Sub Navigation */}
        {currentView !== 'detail' && (
          <div className="flex gap-2">
            <button
              className={`btn btn-sm ${currentView === 'dashboard' ? 'btn-primary' : 'btn-ghost'}`}
              onClick={() => setCurrentView('dashboard')}
            >
              <BarChart3 size={14} /> Dashboard
            </button>
            <button
              className={`btn btn-sm ${currentView === 'list' ? 'btn-primary' : 'btn-ghost'}`}
              onClick={() => setCurrentView('list')}
            >
              <List size={14} /> Fragen
            </button>
          </div>
        )}
      </div>

      {/* View Router */}
      {currentView === 'dashboard' && (
        <QADashboard onNavigateToQuestion={handleSelectQuestion} />
      )}

      {currentView === 'list' && (
        <QAQuestionList onSelectQuestion={handleSelectQuestion} />
      )}

      {currentView === 'detail' && selectedQuestionId && (
        <QAQuestionDetail
          questionId={selectedQuestionId}
          onBack={handleBack}
          onNavigate={handleSelectQuestion}
        />
      )}
    </div>
  );
};
